import React, { useState } from 'react'
import { FaBell, FaBrain, FaUserAlt} from 'react-icons/fa'
import { NavLink, Link } from 'react-router-dom'
import logo from '../images/logo.svg'
import FormControl from '../Form/FormControl'
import * as Yup from 'yup'
import { Formik, Form} from 'formik'
import { Data } from '../sections/ChallengeData'
import Modal from 'react-modal'
import '../Styles/StudentPage.css'

Modal.setAppElement('#root')
const requestInfo= {
    title: '',
    description: '',
    category: '',
    file: ''

}

const onSubmit = values  => {
    console.log('New User', values)
} 

    const requestSchema = Yup.object({
        title: Yup.string()
            .required('Required!'),
        description: Yup.string()
            .required('Required!'),
        category: Yup.string()
            .required('Required!'),
        file: Yup.mixed().required()

    })

    const dropDowOptions = [
        {
            key: 'Select an option' ,
            value: '' 
          },
        {
            key: 'Question',
            value: 'Question'
          },
        {
            key: 'Project',
            value: 'Project'
          },
        {
            key: 'Assignment',
            value: 'Assignment'
          },
    ]


const StudentPage = () => {
    const [modalIsOpen, setModalIsOpen] = useState(false)
   

    return (
        <>
            <nav className='dashboard-nav'>
                    <NavLink to="/" className="nav-logo">
                        <img src={logo} alt="" className="logo" />
                        <h3 className="logo-text">
                            WorkMate
                        </h3>
                    </NavLink>

                    

                    <ul className='menu'>
                        <li>
                            <Link to='/AskQuestions' className='q-cta'> 
                                    Ask Questions
                            </Link>
                        </li>
                            <li className="drop">
                                <Link>
                                        <FaBell className='bell-icon'/>
                                </Link>
                                <ul className="notification-drop">
                                    <li>
                                    Lorem ipsum dolor sit amet.
                                    </li> 
                                    <li>
                                    Lorem ipsum dolor sit amet.
                                    </li> 
                                    <li>
                                    Lorem ipsum dolor sit amet.
                                    </li> 
                                </ul>
                            </li>

                            <li className="drop">
                                <Link>
                                        <FaUserAlt className='user-icon'/>
                                </Link>
                                <ul className="user-drop">
                                    <li>
                                        Profile
                                    </li>
                                    <li>
                                        Settings
                                    </li>
                                    <li>
                                        Log Out
                                    </li>
                                </ul>
                            </li>
                    </ul>

                    
                </nav>

                {/* end of nav///// */}

                <main className="body">
                    <div className="dashboard">
                        <div className="answer-box">
                            <div className="answer-box-head">
                                <FaBrain className='icon'/>
                                Answers 
                            </div>
                            <div className="answer-box-content">
                                    <h3>
                                        What do you need to know?
                                    </h3>
                                    <div className="btn-group">
                                        <div className="q-cta" 
                                            onClick={() => setModalIsOpen(true)}> 
                                            Ask Your Question
                                        </div>
                                        <Modal 
                                        isOpen={modalIsOpen}

                                                onRequestClose={() => setModalIsOpen(false)}
                                                style={{
                                                    overlay: {
                                                      position: 'fixed',
                                                      top: 0,
                                                      left: 0,
                                                      right: 0,
                                                      bottom: 0,
                                                      backgroundColor: 'rgba(24, 23, 23, 0.75)'
                                                    },
                                                    content: {
                                                      position: 'absolute',
                                                      top: '15vh',
                                                      left: '40px',
                                                      right: '40px',
                                                      height: 'auto',
                                                      bottom: 'auto',
                                                      border: '1px solid #ccc',
                                                      background: '#fff',
                                                      overflow: 'auto',
                                                      WebkitOverflowScrolling: 'touch',
                                                      borderRadius: '4px',
                                                      outline: 'none',
                                                      padding: '20px',
                                                      
                                                    }
                                                  }}>
                                                            <div className="modal-content">
                                                                
                                                            <Formik 
                                                                    initialValues={requestInfo}
                                                                    validationSchema={requestSchema}
                                                                    onSubmit={onSubmit}>

                                                                        {formik => (
                                                                            <Form>

                                                                                <div className="d-grid">
                                                                                    <FormControl
                                                                                        control='input'
                                                                                            type='text'
                                                                                                label='title'
                                                                                                    name='title'
                                                                                                        placeholder='Title...'/>

                                                                                    <FormControl
                                                                                        control='select'
                                                                                                name='Category'
                                                                                                    options={dropDowOptions}/>

                                                                                </div>
                                                                                

                                                                                <FormControl
                                                                                    control='textarea'
                                                                                                name='description'
                                                                                                placeholder='Description...'/>


                                                                                    {/* <FormControl
                                                                                        control='file'
                                                                                            type='file'

                                                                                                    name='file'
                                                                                                        placeholder='Title...'/> */}

                                                                                

                                                                                

                                                                                


                                                                                <button type='submit' className='submit'>Submit</button>
                                                                            </Form>
                                                                        )}

                                                                    </Formik>
                                                               
                                                            </div>
                                    </Modal>



                                    </div>
                            </div>
                            {/* <div className="exercise">
                                .<FaCube className='icon'/>
                                <div className="content">
                                    <h4>
                                        Answer 5 questions from any subject to gain 50 points
                                    </h4>
                                    <div className="cta">
                                        Start
                                    </div>
                                </div>
                            </div> */}
                        </div>
                        <div className="tasks">
                            <div className="challenges">
                                <div className="head">
                                    Challenges
                                </div>
                                <ul className="challenge-list">
                                    {Data.map((item, index) => {
                                        return (
                                            <li className="item">
                                               <div className="icon">
                                                 {item.icon}
                                               </div>
                                                
                                                <div className="content">
                                                    {item.title}
                                                  <div className="duration">
                                                  {item.timeDuration}
                                                  <div className="cta">
                                                  {item.cta}
                                                  </div>
                                                  </div>
                                                </div>
                                            </li>
                                        )
                                    })  

                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </main>


        </>
    )
}

export default StudentPage
